var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.meta.head == null || _vm.$route.meta.head)?_c('AppHead'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"MainContainer"},[_c('router-view')],1),_vm._v(" "),(_vm.$route.meta.foot == null || _vm.$route.meta.foot)?_c('AppFoot'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4fbce9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 